import { Link } from 'react-router-dom';

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  icon?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeader({
  title,
  subtitle,
  icon,
  moreTo,
  moreLabel = '查看更多',
}: SectionHeaderProps) {
  return (
    <div className="mb-6 flex items-end justify-between gap-4">
      <div className="flex items-center gap-3">
        {icon && (
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary-500/15 text-xl text-primary-400">
            <i className={icon} aria-hidden="true" />
          </span>
        )}
        <div>
          <h2 className="font-heading text-xl font-extrabold text-foreground-50 md:text-2xl">{title}</h2>
          {subtitle && <p className="mt-1 text-sm text-foreground-500">{subtitle}</p>}
        </div>
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="hidden shrink-0 items-center gap-1 whitespace-nowrap text-sm font-semibold text-foreground-300 transition-colors hover:text-primary-400 sm:flex"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line" aria-hidden="true" />
        </Link>
      )}
    </div>
  );
}